import { Card } from "../_shared/card";
import { IconWallet } from "../_shared/icons";
import { ProgressBar } from "../_shared/progress-bar";
import { navigate } from "../_shared/router";
import {
  payments,
  paymentsTotalAmountCents,
  paymentsTotalPaidCents,
} from "../_data/mock";

function formatEuros(cents: number) {
  return (cents / 100).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  });
}

export function PaymentsCard() {
  const progress = paymentsTotalPaidCents / paymentsTotalAmountCents;
  return (
    <Card
      title="Paiements"
      icon={<IconWallet width={18} height={18} />}
      onClick={() => navigate("payments")}
      titleSize="sm"
    >
      <ul className="mb-4 space-y-1.5 text-[14px] text-[var(--text-2)]">
        {payments.slice(0, 2).map((p) => (
          <li key={p.id} className="flex items-start gap-1.5">
            <span
              aria-hidden
              className="mt-2 size-1 shrink-0 rounded-full bg-[var(--text-3)]"
            />
            <span className="truncate">{p.label}</span>
          </li>
        ))}
      </ul>
      <p className="mb-2 text-[14px] font-bold text-[var(--text-1)]">
        {formatEuros(paymentsTotalPaidCents)}
        <span className="font-normal text-[var(--text-2)]">
          {" "}
          sur {formatEuros(paymentsTotalAmountCents)}
        </span>
      </p>
      <ProgressBar progress={progress} />
    </Card>
  );
}
